function requestQuoteDialog () {
  return {
    restrict: 'E',
    templateUrl: '/admin/dialogs/request-quote/request-quote-dialog.html?$$REVISION$$'
  }
}

export { requestQuoteDialog }
